import { useIntl } from '@/intl'
import { useState } from 'react'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    title: translate({ id: 'orders.form.executionEvents.dynamicLoadsCf.customFields' }),
    undeclared: translate({ id: 'orders.form.executionEvents.dynamicLoadsCf.undeclared' }),
  }))

  return api
}
